export default {
  paper: {
    overflow: 'hidden',
  },
};
